import { NgModule } from '@angular/core';
import { CustomSearchComponent } from './custom-search.component';

@NgModule({
  imports: [CustomSearchComponent],
  exports: [CustomSearchComponent]
})
export class CustomSearchModule { }
